import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/founder/phone-1.webp")